"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var axios_1 = require("axios");
var package_json_1 = require("./package.json");
/**
 * Available environments to use.
 * @enum
 */
exports.Environment = {
    /**
     * development environment
     * @type {string}
     */
    develop: "https://dev.ddb.arup.com/api",
    /**
   * sandbox environment
   * @type {string}
   */
    sandbox: "https://sandbox.ddb.arup.com/api",
    /**
   * production environment
   * @type {string}
   */
    production: "https://ddb.arup.com/api"
};
axios_1.default.defaults.baseURL = exports.Environment.production;
axios_1.default.defaults.headers.common['Version'] = package_json_1.version.split('.')[0];
axios_1.default.defaults.headers.common['App-Client-Type'] = 'Typescript SDK';
